// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/csv_upload_history_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/csv_upload_history_model.proto.
 */
export const file_bffuser_v1_csv_upload_history_model: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ1c2VyL3YxL2Nzdl91cGxvYWRfaGlzdG9yeV9tb2RlbC5wcm90bxIKYmZmdXNlci52MSLEAgoQQ3N2VXBsb2FkSGlzdG9yeRIKCgJpZBgBIAEoCRItCglkYXRhX3R5cGUYAiABKA4yGi5iZmZ1c2VyLnYxLlVwbG9hZERhdGFUeXBlEigKBnJlc3VsdBgDIAEoDjIYLmJmZnVzZXIudjEuVXBsb2FkUmVzdWx0EhMKC3VwbG9hZGVkX2J5GAQgASgJEi8KC3VwbG9hZGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIVCg1jc3ZfZmlsZV9uYW1lGAYgASgJEhcKD3VuY2hhbmdlZF9jb3VudBgHIAEoBRIRCgluZXdfY291bnQYCCABKAUSFQoNY2hhbmdlZF9jb3VudBgJIAEoBRIVCg1kZWxldGVkX2NvdW50GAogASgFEhQKDGVycm9yX3JlYXNvbhgLIAEoCSq2AgoOVXBsb2FkRGF0YVR5cGUSIAocVVBMT0FEX0RBVEFfVFlQRV9VTlNQRUNJRklFRBAAEiMKH1VQTE9BRF9EQVRBX1RZUEVfU1VQUExZXzQ4X0RBVEEQARIkCiBVUExPQURfREFUQV9UWVBFX0JJTEFURVJBTF9UUkFERRACEiEKHVVQTE9BRF9EQVRBX1RZUEVfQ0lTX0NPTlRSQUNUEAMSJAogVVBMT0FEX0RBVEFfVFlQRV9TUE9UX0JJRF9OT1JNQUwQBBIjCh9VUExPQURfREFUQV9UWVBFX1NQT1RfQklEX0JMT0NLEAUSIQodVVBMT0FEX0RBVEFfVFlQRV9JTlRSQURBWV9CSUQQBhImCiJVUExPQURfREFUQV9UWVBFX0NVU1RPTUVSX0NPTlRSQUNUEAcqYgoMVXBsb2FkUmVzdWx0Eh0KGVVQTE9BRF9SRVNVTFRfVU5TUEVDSUZJRUQQABIZChVVUExPQURfUkVTVUxUX1NVQ0NFU1MQARIYChRVUExPQURfUkVTVUxUX0ZBSUxFRBACQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * CsvUploadHistory は確定実行 1 回分の記録。
 *
 * @generated from message bffuser.v1.CsvUploadHistory
 */
export type CsvUploadHistory = Message<"bffuser.v1.CsvUploadHistory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.UploadDataType data_type = 2;
   */
  dataType: UploadDataType;

  /**
   * @generated from field: bffuser.v1.UploadResult result = 3;
   */
  result: UploadResult;

  /**
   * 投入者 (= member_id)。表示名解決は frontend が
   * UserDirectoryService.ListMembers 併用で行う (ListMembers に不在の id は
   * フォールバック表示)。
   *
   * @generated from field: string uploaded_by = 4;
   */
  uploadedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 5;
   */
  uploadedAt?: Timestamp;

  /**
   * @generated from field: string csv_file_name = 6;
   */
  csvFileName: string;

  /**
   * @generated from field: int32 unchanged_count = 7;
   */
  unchangedCount: number;

  /**
   * @generated from field: int32 new_count = 8;
   */
  newCount: number;

  /**
   * @generated from field: int32 changed_count = 9;
   */
  changedCount: number;

  /**
   * @generated from field: int32 deleted_count = 10;
   */
  deletedCount: number;

  /**
   * @generated from field: string error_reason = 11;
   */
  errorReason: string;
};

/**
 * Describes the message bffuser.v1.CsvUploadHistory.
 * Use `create(CsvUploadHistorySchema)` to create a new message.
 */
export const CsvUploadHistorySchema: GenMessage<CsvUploadHistory> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_csv_upload_history_model, 0);

/**
 * UploadDataType は CSV アップロード履歴が記録するデータ種別
 * (ADR csv-upload-history-best-effort-recording.md の記録 seam)。
 *
 * @generated from enum bffuser.v1.UploadDataType
 */
export enum UploadDataType {
  /**
   * @generated from enum value: UPLOAD_DATA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_DATA_TYPE_SUPPLY_48_DATA = 1;
   */
  SUPPLY_48_DATA = 1,

  /**
   * @generated from enum value: UPLOAD_DATA_TYPE_BILATERAL_TRADE = 2;
   */
  BILATERAL_TRADE = 2,

  /**
   * CIS契約マスタ (旧称: 顧客情報 契約推移)。DB smallint 値 3 は据え置きで、
   * 既存履歴行の意味は変わらない (cis-contract-master.md への spec 改称に追従)。
   *
   * @generated from enum value: UPLOAD_DATA_TYPE_CIS_CONTRACT = 3;
   */
  CIS_CONTRACT = 3,

  /**
   * スポット通常入札 CSV (spot-bid-normal-csv-import.md)。
   *
   * @generated from enum value: UPLOAD_DATA_TYPE_SPOT_BID_NORMAL = 4;
   */
  SPOT_BID_NORMAL = 4,

  /**
   * スポットブロック入札 CSV (spot-bid-block-csv-import.md)。
   *
   * @generated from enum value: UPLOAD_DATA_TYPE_SPOT_BID_BLOCK = 5;
   */
  SPOT_BID_BLOCK = 5,

  /**
   * 時間前入札 CSV (intraday-csv-import.md)。
   *
   * @generated from enum value: UPLOAD_DATA_TYPE_INTRADAY_BID = 6;
   */
  INTRADAY_BID = 6,

  /**
   * 顧客契約 CSV (customer-contract.md)。
   *
   * @generated from enum value: UPLOAD_DATA_TYPE_CUSTOMER_CONTRACT = 7;
   */
  CUSTOMER_CONTRACT = 7,
}

/**
 * Describes the enum bffuser.v1.UploadDataType.
 */
export const UploadDataTypeSchema: GenEnum<UploadDataType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_csv_upload_history_model, 0);

/**
 * UploadResult は CSV アップロード履歴 1 行の成否。
 *
 * @generated from enum bffuser.v1.UploadResult
 */
export enum UploadResult {
  /**
   * @generated from enum value: UPLOAD_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_RESULT_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: UPLOAD_RESULT_FAILED = 2;
   */
  FAILED = 2,
}

/**
 * Describes the enum bffuser.v1.UploadResult.
 */
export const UploadResultSchema: GenEnum<UploadResult> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_csv_upload_history_model, 1);

